export default function () {
  const popup = document.querySelector(".popup-appoint");
  const form = document.querySelector(".popup-appoint");
  const steps = document.querySelectorAll(".appoint-step");

  function showPopup() {
    goToStep(0);
    popup.classList.add("is-visible");
  }

  function hidePopup() {
    popup.classList.remove("is-visible");
    form.reset();
  }

  function goToStep(n) {
    steps.forEach((el, i) => {
      el.classList.toggle("is-active", i === n);
    });
  }

  steps.forEach((el, i) => {
    el.querySelector(".appoint-step__next-btn")?.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        if (i !== steps.length - 1) {
          goToStep(i + 1);
        }
      },
    );

    el.querySelector(".appoint-step__prev-btn")?.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        if (i !== 0) {
          goToStep(i - 1);
        }
      },
    );
  });

  document.querySelectorAll('[data-show="appoint-quiz"]').forEach((element) => {
    element.addEventListener("click", () => {
      // Если посетитель только щёлкнул по кнопке расчёта стоимости но,
      // ещё не прошёл квиз, то в Яндекс.Метрику отправится событие "click"
      window.sendMetrikaEvent("click");

      showPopup();
    });
  });

  popup.querySelector(".appoint-close-button").addEventListener("click", (e) => {
    e.preventDefault();
    hidePopup();
  });

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    const formData = new FormData(form);
    let data = {
      name: formData.get("name"),
      phone: formData.get("phone"),
      comment: "",
    };
    if (formData.has("jaw[]")) {
      data.comment += `Нужно восстановить: ${formData.getAll("jaw[]").join(", ")}.\n`;
    }

    if (formData.has("dentures")) {
      data.comment += `Съёмные протезы: ${formData.get("dentures")}.\n`;
    }

    if (formData.has("teeth")) {
      data.comment += `Зубы отсутствуют: ${formData.get("teeth")}.\n`;
    }

    if (formData.has("extraction")) {
      data.comment += `Удаление зубов: ${formData.get("extraction")}.\n`;
    }

    if (formData.has("disease[]")) {
      const diseases = formData.getAll("disease[]");

      if (diseases.includes("нет")) {
        data.comment += "Заболевания: нет.\n";
      } else if (diseases.includes("затрудняюсь ответить")) {
        data.comment += "Заболевания: затрудняюсь ответить.\n"
      } else {
        data.comment += `Заболевания: ${diseases.join(", ")}.\n`
      }
    }

    if (formData.has("want[]")) {
      data.comment += `Хочу получить: ${formData.getAll("want[]").join(", ")}.\n`;
    }

    if (formData.has("comment")) {
      data.comment += `Комментарий: ${formData.get("comment")}`;
    }

    hidePopup();
    window.popupLoader.show();

    fetch('/api/send', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        if (!response.ok) {
          window.popupLoader.hide();
          window.popupCallback.showError();
          return;
        }
        return response.json();
      })
      .then(result => {
        window.popupLoader.hide();
        window.popupCallback.showSuccess();
        // Событие QUIZ отправляется когда пользователь успешно отправил заявку
        window.sendMetrikaEvent("QUIZ");
      })
      .catch(error => {
        window.popupLoader.hide();
        window.popupCallback.showError();
      });
  });
}
